module.exports = __webpack_public_path__ + "img/step_four_en.bac2e8c4.png";